var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 35.338A19.422 19.422 0 1069.5 54.76 19.483 19.483 0 0050 35.338zM43.43 48.19c-3.95 3.94-6.32 8.54-6.72 12.33a14.217 14.217 0 01-1.21-5.76 14.498 14.498 0 0120.18-13.28c-3.78.42-8.34 2.79-12.25 6.71z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4 25.24H73.565a3.017 3.017 0 01-2.797-1.92l-2.065-5.37a6.635 6.635 0 00-6.157-4.23H37.454a6.633 6.633 0 00-6.156 4.229l-2.066 5.37a3.016 3.016 0 01-2.797 1.921H11.6a6.607 6.607 0 00-6.6 6.6v47.84a6.607 6.607 0 006.6 6.6h76.8a6.607 6.607 0 006.6-6.6V31.84a6.607 6.607 0 00-6.6-6.6zM50 79.182A24.422 24.422 0 1174.5 54.76 24.489 24.489 0 0150 79.182zm31.283-36.26a4 4 0 114-4 4 4 0 01-4 4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.496ec444.svg";
export { ForwardRef as ReactComponent };